<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <v-slide-x-reverse-transition>
          <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        </v-slide-x-reverse-transition>
        <div class="pa-2">
          <v-card-title>
            อัพเดทล่าสุด: {{ data_list.user_name }} {{ data_list.updated_at }}
          </v-card-title>
          <v-card-text>
            <quillEditor ref="myQuillEditor" v-model="data_list.content"/>
          </v-card-text>
        </div>
        <div class="text-center pa-3">
          <v-btn large class="white--text grad-success-bg mobile_btn" style="font-size: 18px" @click="save_data">บันทึกการแก้ไข</v-btn>
        </div>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
import {quillEditor} from 'vue-quill-editor'
import Swal from "sweetalert2";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "company_information",
  components: {
    quillEditor
  },
  data() {
    return {
      loading_page: false,
      overlay: false,
      alert_success: false,
      data_list: [],
      editorOption: {
        modules: {
          toolbar: ['bold', 'italic', 'underline', 'strike']
        }
      },
    }
  },
  methods: {
    get_data() {
      this.loading_page = true
      HTTP.post('/manage-website/aboutus/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.data_list = res.data.object
            }
          })
    },
    save_data() {
      Swal.fire({
        title: 'คุณต้องการบันทึกข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post('/manage-website/aboutus/edit', {
            user_id: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
            id: this.data_list.id,
            content: this.data_list.content,
          }).then((res) => {
            if (res.data.success === true) {
              this.alert_success = true
              this.get_data()
              setTimeout(() => this.alert_success = false, 1000)
            }
          })
        }
      })
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.mobile_btn {
  width: 30%;
}
@media only screen and (max-width: 1180px) {
  .mobile_btn {
    width: 40%;
  }
}
@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
}
</style>
